import usePlaid from "./usePlaid";
import PlaidWarning from "./PlaidWarning";
import Typography from "@mui/material/Typography";
import color from "context/MaterialUITheme/color";
import OtherEmploymentDialog from "./OtherEmploymentDialog";
import CTrackerTimelineItem, {
  trackerStatusColor,
} from "components/CTimelineItem";
import { Fragment, useState } from "react";
import useTracker from "components/CTracker/useTrackerContext";
import CoborrowerInvite from "components/CTracker/StepsDialogs/CoborrowerInvite";

const IncomeVerification: React.FC = () => {
  const plaid = usePlaid();
  const { loan, type } = useTracker();
  const isBorrower = type === "borrower";
  const [coborrowerInviteIsOpen, setCoborrowerInviteIsOpen] = useState(false);
  const step = isBorrower ? loan?.borrowerSteps : loan?.coborrowerSteps;
  const status = step?.incomeVerification?.status ?? "pending";
  const message = step?.incomeVerification?.message ?? "";
  const error = step?.incomeVerification?.error?.error ?? "";

  return (
    <CTrackerTimelineItem
      status={status}
      title="Income"
      tooltip="Plaid is our trusted partner to obtain income details with minimal steps. You’ll be prompted to provide your income source(s), based on the type of employment you stated when filling out your application."
      {...(isBorrower &&
        status === "failed" &&
        !(error === "DOCS_MISSING" || error === "PAYSTUB_TOO_OLD") && {
          actions: [
            {
              message: "Add Co-Borrower",
              onClick: () => setCoborrowerInviteIsOpen(true),
            },
          ],
        })}
      {...(status === "failed" &&
        (error === "DOCS_MISSING" || error === "PAYSTUB_TOO_OLD") && {
          actions: [
            {
              message: "Add Document",
              onClick: plaid.loadEmployment,
            },
          ],
        })}
    >
      <Typography
        variant="h6"
        color={color[trackerStatusColor[status] as keyof typeof color]}
      >
        {status === "analyzing" && "Analyzing"}
        {status === "failed" && message}
        {status === "success" && message}
        {isBorrower &&
          status === "success" &&
          loan?.coborrowerInvite &&
          loan.coborrowerSteps?.incomeVerification.status !== "success" && (
            <Fragment>
              <br />
              Waiting on the borrower to complete their steps
            </Fragment>
          )}
      </Typography>
      <PlaidWarning
        open={
          (isBorrower &&
            plaid.warningIsOpen &&
            !plaid.otherEmploymentDialogIsOpen &&
            !coborrowerInviteIsOpen) ||
          (!isBorrower &&
            plaid.warningIsOpen &&
            !plaid.otherEmploymentDialogIsOpen)
        }
        onAccept={plaid.loadEmployment}
      />
      <CoborrowerInvite
        open={coborrowerInviteIsOpen}
        onClose={() => setCoborrowerInviteIsOpen(false)}
      />
      <OtherEmploymentDialog
        open={
          (isBorrower && plaid.otherEmploymentDialogIsOpen) ||
          (!isBorrower && plaid.otherEmploymentDialogIsOpen)
        }
        onAccept={() => {
          plaid.setOtherEmploymentDialogIsOpen(false);
          plaid.loadEmployment();
        }}
        onDismiss={async () => {
          plaid.setOtherEmploymentDialogIsOpen(false);
          await plaid.setFlags({ offeredAddingEmployment: true });
        }}
      />
    </CTrackerTimelineItem>
  );
};

export default IncomeVerification;
